import { render, staticRenderFns } from "./CriterionForm.vue?vue&type=template&id=97461dfc"
import script from "./CriterionForm.vue?vue&type=script&lang=ts"
export * from "./CriterionForm.vue?vue&type=script&lang=ts"
import style0 from "./CriterionForm.vue?vue&type=style&index=0&id=97461dfc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports